import { motion } from "framer-motion";
import { Users, FolderKanban, ReceiptText, FileClock } from "lucide-react";
import { Reveal } from "./Reveal";

const ANSWER = [
  { icon: Users, count: "3", text: "customers need a follow-up" },
  { icon: FolderKanban, count: "2", text: "projects are behind" },
  { icon: ReceiptText, count: "4", text: "invoices are overdue" },
  { icon: FileClock, count: "1", text: "quote has been waiting 7 days" },
];

export default function AskBusiness() {
  return (
    <section className="py-20 lg:py-28 bg-[#F8FAFC]">
      <div className="max-w-3xl mx-auto px-4 sm:px-8 text-center">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-brand-teal font-semibold mb-4">
            The whole idea, in one question
          </p>
          <h2 className="font-display font-semibold tracking-tight leading-[1.12] text-brand-navy text-2xl sm:text-3xl lg:text-4xl mb-10">
            Ask your business a question. Get an answer.
          </h2>
        </Reveal>

        <Reveal delay={0.12}>
          <div data-testid="ask-business-demo" className="text-left">
            <div className="flex justify-end mb-4">
              <div className="rounded-2xl rounded-br-md bg-brand-navy text-white px-6 py-4 max-w-md shadow">
                <p className="font-display font-medium text-base sm:text-lg">
                  "What needs my attention today?"
                </p>
                <p className="text-[11px] text-slate-400 mt-1">The owner · 7:58am</p>
              </div>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-2xl rounded-bl-md bg-white border border-slate-200 px-6 sm:px-8 py-6 max-w-md shadow-[0_20px_40px_-15px_rgba(14,20,51,0.08)]"
            >
              <ul className="space-y-3.5">
                {ANSWER.map((a, i) => (
                  <motion.li
                    key={a.text}
                    initial={{ opacity: 0, x: 14 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.4 + i * 0.15, duration: 0.4 }}
                    className="flex items-center gap-3.5"
                  >
                    <span className="w-9 h-9 rounded-full bg-brand-tealsoft text-brand-teal flex items-center justify-center shrink-0">
                      <a.icon size={15} />
                    </span>
                    <p className="text-sm sm:text-base text-slate-700">
                      <span className="font-display font-bold text-brand-navy text-lg mr-1.5">{a.count}</span>
                      {a.text}
                    </p>
                  </motion.li>
                ))}
              </ul>
              <p className="mt-5 pt-4 border-t border-slate-100 text-xs text-slate-400">
                Answered from the business's own live record — no report built, no one interrupted.
              </p>
            </motion.div>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-10 text-base text-slate-600 leading-relaxed max-w-xl mx-auto">
            No dashboards to learn, no numbers to assemble. The system keeps
            watch; you get the short list.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
